import { Descriptions, Select, Table, TableColumnsType } from 'antd';
import _ from 'lodash';
import moment from 'moment';
import QueryString from 'qs';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import {
  cancelEventAttendance,
  createEventAttendance,
  getEventInfo,
  getEventRegister,
} from '../../../api/events.api';
import { cancelEventRegister } from '../../../api/refunds.api';
import Button from '../../../components/Button';
import Checkbox from '../../../components/Checkbox';
import DownloadButton from '../../../components/DownloadButton';
import ErrorResponse from '../../../components/ErrorResponse';
import SelectEmployeeModal from '../../../components/event/education/register/modals/SelectEmployeeModal';
import ConfirmPaymentModal from '../../../components/event/modals/ConfirmPaymentModal';
import SimpleHeader from '../../../components/layout/SimpleHeader';
import Loader from '../../../components/Loader';
import Pagination from '../../../components/Pagination';
import useAuth from '../../../hooks/useAuth';
import useAxios from '../../../hooks/useAxios';
import useNotification from '../../../hooks/useNotification';
import config from '../../../lib/config';
import exportTable from '../../../lib/exportTable';
import { getCommonCodeLabel } from '../../../lib/store';
import {
  IEventRegister,
  IGetEventInfo,
  IGetEventRegister,
} from '../../../models/events.model';
import { doLogout } from '../../../store/auth.slice';
import { RootState } from '../../../store/rootReducer';

interface IMatch {
  eventNo: string;
}

const EducationRegister = () => {
  const { t } = useTranslation();
  const { writeAuthYn } = useAuth();
  const dispatch = useDispatch();
  const match = useRouteMatch<IMatch>();
  const eventNo = Number(match.params.eventNo);
  const history = useHistory();
  const location = useLocation();
  const query = QueryString.parse(location.search, { ignoreQueryPrefix: true });
  const { campusData } = useSelector((state: RootState) => state.campusData);
  const { infoNotification, successNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios<IGetEventInfo>();
  const { data: res2, isLoading: isLoading2, error: error2, execute: execute2 } = useAxios<IGetEventRegister>();
  // for excel download
  const { data: res3, isLoading: isLoading3, error: error3, execute: execute3 } = useAxios<IGetEventRegister>();
  const { data: submitRes, isLoading: submitIsLoading, error: submitError,
    execute: submitExecute } = useAxios();
  const { data: cancelRes, isLoading: cancelIsLoading, error: cancelError, execute: cancelExecute } = useAxios();

  const [page, setPage] = useState(1);
  const [param, setParam] = useState({});
  const [campusCode, setCampusCode] = useState<string>();
  const [requireName, setRequireName] = useState('');
  const [webId, setWebId] = useState('');

  const [selectEmployeeVisible, setSelectEmployeeVisible] = useState(false);
  const [isPaymentSelectAll, setIsPaymentSelectAll] = useState(false);
  const [paymentSelects, setPaymentSelects] = useState<number[]>([]);
  const [isCancelSelectAll, setIsCancelSelectAll] = useState(false);
  const [cancelSelects, setCancelSelects] = useState<number[]>([]);
  const [confirmPaymentVisible, setConfirmPaymentVisible] = useState(false);

  useEffect(() => {
    doGetEventRegister();
  }, [location]);

  useEffect(() => {
    if (cancelRes && !cancelIsLoading) {
      doGetEventRegister();
      successNotification(t('common.message.cancel'));
    }
  }, [cancelRes, cancelIsLoading]);

  useEffect(() => {
    if (submitRes && !submitIsLoading) {
      doGetEventRegister();
      successNotification(t('common.message.save1'));
    }
  }, [submitRes, submitIsLoading]);

  useEffect(() => {
    if (res3?.data && !isLoading3) {
      const data: any = _.cloneDeep(res3.data);
      data.forEach((item: any) => {
        item.attendStatus = getCommonCodeLabel('BR0008', item.attendStatus, 'ko');
        item.regDate = moment(item.regDate).format('YYYY.MM.DD HH:mm');
        item.attendSaveDate = item.attendSaveDate ? moment(item.attendSaveDate).format('YYYY.MM.DD HH:mm') : '';
      });
      const newColumns = _.cloneDeep(columns).filter((_: any, i: number) => i !== 4);
      const currentDate = moment(new Date());
      exportTable(newColumns, data, `${t('event.education.1')}_(${currentDate.format('YYYYMMDD')})`, t('event.education.1'), [12, 10, 20, 10, 20, 20]);
    }
  }, [res3, isLoading3]);


  const doGetEventRegister = () => {
    execute(getEventInfo('ED', eventNo));

    const _param: any = {
      pageNo: page,
      perPage: config.pageSize,
    };

    if (query.page) {
      const _page = Number(query.page);
      setPage(_page);
      _param.page = _page;
    }
    if (query.campusCode) {
      const _campusCode = String(query.campusCode);
      setCampusCode(_campusCode);
      _param.campusCode = _campusCode;
    }
    if (query.requireName) {
      const _requireName = String(query.requireName);
      setRequireName(_requireName);
      _param.requireName = _requireName;
    }
    if (query.webId) {
      const _webId = String(query.webId);
      setWebId(_webId);
      _param.webId = _webId;
    }

    execute2(getEventRegister('ED', eventNo, _param));
    _param.page = _param.pageNo;
    delete _param.pageNo;
    delete _param.perPage;
    setParam(_param);
  };

  const onSetPaymentSelects = (paymentNo: number) => {
    if (paymentSelects.includes(paymentNo)) {
      setPaymentSelects(paymentSelects.filter((item) => item !== paymentNo));
      setIsPaymentSelectAll(false);
    } else {
      setPaymentSelects([...paymentSelects, paymentNo]);
    }
  };

  const onSetPaymentSelectAll = () => {
    if (isPaymentSelectAll) {
      setPaymentSelects([]);
      setIsPaymentSelectAll(false);
    } else {
      const _selects: number[] = [];
      res2?.data?.forEach(item => {
        if (item.paymentYn !== 'Y') {
          _selects.push(item.eventRequireCode);
        }
      });
      setPaymentSelects(_selects);
      setIsPaymentSelectAll(true);
    }
  };

  const onSetCancelSelects = (eventRequireCode: number) => {
    if (cancelSelects.includes(eventRequireCode)) {
      setCancelSelects(
        cancelSelects.filter((item) => item !== eventRequireCode),
      );
      setIsCancelSelectAll(false);
    } else {
      setCancelSelects([...cancelSelects, eventRequireCode]);
    }
  };

  const onSetCancelSelectAll = () => {
    if (isCancelSelectAll) {
      setCancelSelects([]);
      setIsCancelSelectAll(false);
    } else {
      const _selects: number[] = [];
      res2?.data?.forEach((item) => {
        if (item.cancelYn === 'N' && !item.attendStatus) {
          _selects.push(item.eventRequireCode);
        }
      });
      setCancelSelects(_selects);
      setIsCancelSelectAll(true);
    }
  };

  const onSearch = () => {
    const param: any = { page: 1 };

    if (campusCode) param.campusCode = campusCode;
    if (requireName) param.requireName = requireName;
    if (webId) param.webId = webId;

    history.push(
      `/event/education/${eventNo}/register?${QueryString.stringify(param)}`,
    );
  };

  const onConfirmPayment = () => {
    if (!paymentSelects.length) {
      return infoNotification(t('event.education.message9'));
    }

    setConfirmPaymentVisible(true);
  };

  const onCancel = () => {
    if (!cancelSelects.length) {
      return infoNotification(t('event.education.message10'));
    }

    cancelExecute(
      cancelEventRegister({
        eventRequireCode: cancelSelects.join(','),
      }),
    );
  };

  const onSubmit = (eventRequireCode: number) => {
    if (!res?.data?.eventDate || !res?.data?.eventTime) return;

    const timeLimit = moment(
      `${res.data.eventDate}T${res.data.eventTime.replace(':', '')}`,
    ).add(10, 'minutes');
    submitExecute(
      createEventAttendance(eventRequireCode, {
        attendStatus: moment().isAfter(timeLimit) ? 'LT' : 'AT',
      }),
    );
  };

  const onCancelAttendance = (eventRequireCode: number) => {
    cancelExecute(cancelEventAttendance(eventRequireCode));
  };

  const onExportTable = () => {
    execute3(getEventRegister('ED', eventNo, {
      ...param,
      pageNo: 1,
      perPage: 999999999,
    }));
  };

  let columns: TableColumnsType<IEventRegister> = [
    {
      title: t('common.menu.campus'),
      dataIndex: 'campusKorName',
      key: 'campusKorName',
      align: 'center',
    },
    {
      title: t('event.education.column22'),
      dataIndex: 'memKorName',
      key: 'memKorName',
      align: 'center',
    },
    {
      title: 'ID',
      dataIndex: 'webId',
      key: 'webId',
      align: 'center',
    },
    {
      title: t('event.education.column23'),
      dataIndex: 'attendStatus',
      key: 'attendStatus',
      align: 'center',
      render: (value, record) => {
        return value
          ? (
            <>
              {getCommonCodeLabel('BR0008', value, 'ko')}
              {value !== 'AB' && (
                <Button
                  onClick={() => onCancelAttendance(record.eventRequireCode)}
                  className="btn btn-sm btn-secondary btn-w40p ml-1"
                  text={t('common.button.cancel')}
                />
              )}
            </>
            )
          : record.cancelYn === 'Y'
            ? t('common.button.cancel')
            : (
              <Button
                onClick={() => onSubmit(record.eventRequireCode)}
                className="btn btn-sm btn-success btn-w70p"
                text={t('event.education.button6')}
                disabled={Number(res?.data?.paymentAmount) > 0 &&
                    record.paymentYn === 'N'}
              />
              );
      },
    },
    {
      title: t('event.education.column24'),
      dataIndex: 'paymentYn',
      key: 'paymentYn',
      align: 'center',
      render: (value) => (value === 'Y' ? t('common.option.yes') : t('common.option.no')),
    },
    {
      title: (
        <>
          {t('event.education.column25')}{' '}
          <Checkbox
            checked={isPaymentSelectAll}
            onChange={() => {
              onSetPaymentSelectAll();
            }}
            text=""
            disabled={Number(res?.data?.paymentAmount) === 0}
          />
        </>
      ),
      dataIndex: 'eventRequireCode',
      key: 'eventRequireCode',
      align: 'center',
      render: (value, record) => {
        let checked = false;
        if (paymentSelects.includes(value) && record.paymentYn !== 'Y') {
          checked = true;
        }

        return (
          <Checkbox
            checked={checked}
            onChange={() => onSetPaymentSelects(value)}
            text=""
            disabled={
              record.paymentYn === 'Y' || Number(res?.data?.paymentAmount) === 0
            }
          />
        );
      },
    },
    {
      title: (
        <>
          {t('event.education.column26')}{' '}
          <Checkbox
            checked={isCancelSelectAll}
            onChange={() => {
              onSetCancelSelectAll();
            }}
            text=""
          />
        </>
      ),
      dataIndex: 'eventRequireCode',
      key: 'eventRequireCode',
      align: 'center',
      render: (value, record) => {
        let checked = false;
        if ((cancelSelects.includes(value) || isCancelSelectAll) && record.cancelYn === 'N' && !record.attendStatus) {
          checked = true;
        }

        return (
          <Checkbox
            checked={checked}
            onChange={() => onSetCancelSelects(value)}
            text=""
            disabled={record.cancelYn === 'Y' || !!record.attendStatus}
          />
        );
      },
    },
    {
      title: t('event.education.column27'),
      dataIndex: 'regDate',
      key: 'regDate',
      align: 'center',
      render: (value) => moment(value).format('YYYY.MM.DD HH:mm'),
    },
    {
      title: t('event.education.column28'),
      dataIndex: 'attendSaveDate',
      key: 'attendSaveDate',
      align: 'center',
      render: (value) =>
        value ? moment(value).format('YYYY.MM.DD HH:mm') : '',
    },
  ];
  // 행사비 무료인 경우 결제 열 삭제
  if (!Number(res?.data?.paymentAmount)) {
    columns = columns.filter((item, index) => index !== 4 && index !== 5);
  }

  return (
    <div className="content scrollbar">
      {(isLoading || isLoading2 || cancelIsLoading || submitIsLoading) && <Loader />}
      <ErrorResponse error={error} />
      <ErrorResponse error={error2} />
      <ErrorResponse error={error3} />
      <ErrorResponse error={cancelError} />
      <ErrorResponse error={submitError} />
      <SimpleHeader
        iconFile="icon-event-big.svg"
        parentMenu={t('common.menu.event')}
        currentMenu={t('event.education.title6')}
      />

      <div className='comm-table__area rowType'>
        <Descriptions
          bordered
          column={3}
          size="small"
          labelStyle={{ width: '16.6%' }}
          contentStyle={{ width: '16.6%' }}
        >
          <Descriptions.Item label={t('event.education.column10')} span={3}>
            {res?.data?.eventName}
          </Descriptions.Item>
          <Descriptions.Item label={t('event.education.column29')}>
            {res?.data?.requireCount}
          </Descriptions.Item>
          <Descriptions.Item label={t('event.education.column30')}>
            {res?.data?.paymentCount}
          </Descriptions.Item>
          <Descriptions.Item label={t('event.education.column31')}>
            {res?.data?.attendanceRate}
          </Descriptions.Item>
          <Descriptions.Item label={t('event.education.column32')}>
            {res?.data?.normal}
          </Descriptions.Item>
          <Descriptions.Item label={t('event.education.column33')}>
            {res?.data?.late}
          </Descriptions.Item>
          <Descriptions.Item label={t('event.education.column34')}>
            {res?.data?.absent}
          </Descriptions.Item>
        </Descriptions>
      </div>

      <div className="comm-bx__space">
        <div className="comm-btn__area right">
          <Select
            className="w-150p"
            placeholder={t('common.menu.campus')}
            value={campusCode}
            onChange={(value) => setCampusCode(value)}
          >
            <Select.Option value="">{t('common.text.all')}</Select.Option>
            {campusData?.map((item: any) => {
              return (
                <Select.Option key={item.campusCode} value={item.campusCode}>
                  {item.campusKorName}
                </Select.Option>
              );
            })}
          </Select>
          <input
            type="text"
            className="form-control w-150p"
            placeholder={t('event.education.column22')}
            value={requireName}
            onChange={(e) => setRequireName(e.target.value)}
            onKeyPress={(e) => {
              if (e.key === 'Enter') onSearch();
            }}
          />
          <input
            type="text"
            className="form-control w-150p"
            placeholder="ID"
            value={webId}
            onChange={(e) => setWebId(e.target.value)}
            onKeyPress={(e) => {
              if (e.key === 'Enter') onSearch();
            }}
          />
          <div className="comm-btn__area">
            <Button
              className="btn-basic small black"
              onClick={onSearch}
              text={t('common.button.search')}
            />
          </div>
        </div>
      </div>
      <div className="comm-table__area">
        <Table
          columns={columns}
          dataSource={res2?.data}
          pagination={{
            current: page,
            pageSize: config.pageSize,
          }}
          rowKey="eventRequireCode"
        />
      </div>
      
      <div className="comm-bx__between">
        <div className="comm-btn__area">
          <DownloadButton onClick={onExportTable} />
          <Button
            onClick={() => history.push('/event/education')}
            className="btn-basic gray-line"
            text={t('common.button.list')}
          />
          <Button
            onClick={() => {
              history.push(`/event/attendance?eventNo=${eventNo}&type=ED`);
              dispatch(doLogout());
            }}
            className="btn-basic pink-line"
            text={t('event.education.button7')}
          />
        </div>
        <div className="common-paging center">
          <Pagination
            count={res2?.total || 0}
            page={page}
            param={param}
            path={`/event/education/${eventNo}/register`}
          />
        </div>
        <div className="comm-btn__area right">
          <Button
            onClick={() => setSelectEmployeeVisible(true)}
            className="btn-basic pink-line"
            text={t('common.button.add')}
          />
          {Number(res?.data?.paymentAmount) > 0 ? (
            <Button
              onClick={onConfirmPayment}
              className="btn-basic pink"
              text={t('event.education.column25')}
              writeAuthYn={writeAuthYn}
            />
          ) : null}
          <Button
            onClick={onCancel}
            className="btn-basic gray"
            text={t('common.button.cancel')}
          />
        </div>
      </div>

      {selectEmployeeVisible &&
        <SelectEmployeeModal
          visible={selectEmployeeVisible}
          setVisible={setSelectEmployeeVisible}
          eventNo={eventNo}
          doGetEventRegister={doGetEventRegister}
        />
      }
      {confirmPaymentVisible &&
        <ConfirmPaymentModal
          visible={confirmPaymentVisible}
          setVisible={setConfirmPaymentVisible}
          paymentSelects={paymentSelects}
          data1={res?.data}
          data2={res2?.data}
          doGetEventRegister={doGetEventRegister}
        />
      }
    </div>
  );
};

export default EducationRegister;
